import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { FAILURE_REPAIR_MANAGEMENT, REQUEST_REPAIR_MANAGEMENT, SUCCESS_REPAIR_MANAGEMENT } from './actions';

export function repairManagementReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_REPAIR_MANAGEMENT:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_REPAIR_MANAGEMENT:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_REPAIR_MANAGEMENT:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
